import React, { useRef } from 'react';
import { useYouTubePlayer } from '@/hooks/useYouTubePlayer';
import { usePlayerStore } from '@/stores/playerStore';

interface YouTubePlayerProps {
  roomId: string;
}

export const YouTubePlayer: React.FC<YouTubePlayerProps> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { videoId, isPlaying } = usePlayerStore();

  useYouTubePlayer(containerRef);

  return (
    <div className="relative w-full bg-black rounded-lg overflow-hidden shadow-2xl">
      <div className="relative pt-[56.25%]">
        <div
          ref={containerRef}
          id="youtube-player"
          className="absolute top-0 left-0 w-full h-full"
        />

        {!videoId && (
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-purple-900 to-purple-700">
            <div className="text-center text-white">
              <svg className="w-24 h-24 mx-auto mb-4 opacity-50" fill="currentColor" viewBox="0 0 20 20">
                <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
              </svg>
              <p className="text-xl font-medium">No video playing</p>
              <p className="text-sm opacity-75 mt-2">Add a song to start</p>
            </div>
          </div>
        )}
      </div>

      {videoId && (
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
          <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${isPlaying ? 'bg-lime-400 animate-pulse' : 'bg-anthracite-500'}`} />
            <span className="text-white text-sm font-medium">
              {isPlaying ? 'Playing' : 'Paused'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
